import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import packageJson from '../../package.json';

const APP_VERSION = packageJson.version;

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="bg-gray-100 border-t border-gray-200 py-4 px-6">
        <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                    {/* Izquierda - Copyright */}
          <div className="flex items-center space-x-4 text-sm text-gray-600">
            <span>© {currentYear} Pulpou Price Tracking v{APP_VERSION}</span>
          </div>
        
        {/* Centro - Powered by + Logo */}
        <div className="flex items-center space-x-2 text-sm text-gray-600">
          <span>Powered by</span>
          <img 
            src="/logo_pulpou.svg" 
            alt="Pulpou" 
            className="h-6 w-auto"
          />
        </div>
        
        {/* Derecha - Selector de idioma + Debug Switch */}
        <div className="flex items-center space-x-4">
          <span className="text-sm text-gray-600 hidden sm:inline">
            {t('footer.language')}:
          </span>
          <LanguageSelector />
        </div>
      </div>
    </footer>
  </>
  );
};

export default Footer; 